import React from 'react';
import { WORKFLOW_CHAPTERS } from '../data';
import GalleryCard from './GalleryCard';
import styles from '../Home.module.css';

const ChapterVisual: React.FC<{
  chapter: (typeof WORKFLOW_CHAPTERS)[number];
  eager?: boolean;
  /** The deck's figures live in an aria-hidden block, so they are
      decorative (alt=""); the stacked figures are visible content and
      carry the chapter's descriptive alt text. */
  decorative?: boolean;
}> = ({ chapter, eager = false, decorative = false }) =>
  chapter.visual === 'gallery' ? (
    <GalleryCard />
  ) : (
    <div className={styles.phone}>
      <div className={styles.phoneScreen}>
        <img
          src={chapter.screenshot as string}
          alt={decorative ? '' : chapter.alt}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          width="640"
          height="1392"
          draggable={false}
        />
      </div>
    </div>
  );

export default ChapterVisual;
